import { AgGridModule } from '@ag-grid-community/angular';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { NgModule } from '@angular/core';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { BaseEntryLiteratureComponent } from './base-entry-literature-component';
import { ComplementaryCommonComponent } from './complementary-literature/complementary-common/complementary-common.component';
import { ComplimentaryLiteratureComponent } from './complementary-literature/complementary-literature.component';
import { ComplimentaryLiteratureService } from './complementary-literature/services/complementary-literature.service';
import { FeaturedLiteratureComponent } from './featured-literature/featured-literature.component';
import { FeaturedLiteratureService } from './featured-literature/service/featured-literature.service';
import { FundCommentaryComponent } from './fund-commentary/fund-commentary.component';
import { FundCommentaryService } from './fund-commentary/services/fund-commentary.service';
import { ItemDetailComponent } from './item-detail/item-detail.component';
import { ItemDetailService } from './item-detail/services/item-detail.service';
import { LitBannerComponent } from './lit-banner/lit-banner.component';
import { LiteratureDashboardComponent } from './literature-dashboard/literature-dashboard.component';
import { MyliteratureService } from './literature-dashboard/services/myliterature.service';
import { LiteratureDocumentCartComponent } from './literature-document-cart/literature-document-cart.component';
import { DocumentDetailComponent } from './literature-shared-component/document-detail/document-detail.component';
import { DocumentDownloadComponent } from './literature-shared-component/document-download/document-download.component';
import { DocumentFiltersComponent } from './literature-document-listing/document-filters/document-filters.component';
import { FundNameCellRendererComponent } from './literature-shared-component/fund-name-cell-renderer/fund-name-cell-renderer.component';
import { IconColumnComponent } from './literature-shared-component/icon-column/icon-column.component';
import { LiteratureCustomDocumentCardComponent } from './literature-document-listing/literature-custom-document-card/literature-custom-document-card.component';
import { LiteratureDocumentCardContainerComponent } from './literature-shared-component/literature-document-card-container/literature-document-card-container.component';
import { LiteratureDocumentCardComponent } from './literature-shared-component/literature-document-card/literature-document-card.component';
import { LiteratureDocumentListingComponent } from './literature-document-listing/literature-document-listing.component';
import { NoFilterDataOverLayComponent } from './literature-shared-component/no-filter-data-overlay/no-filter-data-overlay.component';
import { LiteratureDocumentListingService } from './literature-document-listing/services/literature-document-listing.service';
import { LiteratureEntryComponent } from './literature-entry/literature-entry.component';
import { FundDocumentCardContainerComponent } from './literature-fund-document/fund-document-card-container/fund-document-card-container.component';
import { FundDocumentCardComponent } from './literature-fund-document/fund-document-card/fund-document-card.component';
import { LiteratureFundDocumentComponent } from './literature-fund-document/literature-fund-document.component';
import { LiteratureFundDocumentService } from './literature-fund-document/services/literature-fund-document.service';
import { LITERATURE_MODULE_IMPORTS } from './literature-imports';
import { LiteratureOrderHistoryDetailComponent } from './literature-order-history-detail/literature-order-history-detail.component';
import { LiteratureOrderHistoryDetailService } from './literature-order-history-detail/services/literature-order-history-detail.service';
import { LiteratureYourCartMailConfirmOrderComponent } from './literature-your-cart-mail-confirm-order/literature-your-cart-mail-confirm-order.component';
import { LiteratureYourCartMailFormComponent } from './literature-your-cart-mail-form/literature-your-cart-mail-form.component';
import { LiteratureYourCartMailOrderSuccessComponent } from './literature-your-cart-mail-order-success/literature-your-cart-mail-order-success.component';
import { LiteratureYourCartMailComponent } from './literature-your-cart-mail/literature-your-cart-mail.component';
import { LiteratureEmailFormComponent } from './literture-email-form/literature-email-form.component';
import { MyCartSummaryComponent } from './my-cart-summary/my-cart-summary.component';
import { MyLiteratureComponent } from './my-literature/my-literature.component';
import { NoRowOverlayRenderMyLiteratureComponent } from './my-literature/no-row-overlay-render/no-row-overlay-render.component';
import { LiteratureOrderHeaderComponent } from './order-history-list/literature-order-header/literature-order-header.component';
import { OrderNameCellRenderComponent } from './order-history-list/name-cell-render/order-name-cell-render.component';
import { NoRowOverlayRenderComponent } from './order-history-list/no-row-overlay-render/no-row-overlay-render.component';
import { OrderHistoryListComponent } from './order-history-list/order-history-list.component';
import { OrderHistoryListService } from './order-history-list/services/order-history-list.service';
import { LiteratureDataService } from './services/literature-data.service';
import { LiteratureFundDataService } from './services/literature-fund-data.service';
import { TopFormService } from './top-forms/service/top-form.service';
import { TopFormsComponent } from './top-forms/top-forms.component';
import { RegulatoryFundNameCellRendererComponent } from './literature-shared-component/regulatory-fund-name-cell-renderer/regulatory-fund-name-cell-renderer.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { LiteraturePreviewComponent } from './literature-preview/literature-preview.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SelectAllGroupHeaderComponent } from './literature-shared-component/select-all-group-header/select-all-group-header.component';
import { SelectCellRendererComponent } from './literature-shared-component/select-cell-renderer/select-cell-renderer.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { SmarshLiteratureListingComponent } from './smarsh-literature-listing/smarsh-literature-listing.component';
import { LiteratureGlobalRegulatoryListingComponent } from './literature-global-regulatory-listing/literature-global-regulatory-listing.component';

// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    LITERATURE_MODULE_IMPORTS,
    AgGridModule.withComponents([
      LiteratureDocumentListingComponent,
      SelectAllGroupHeaderComponent,
      SelectCellRendererComponent,
    ]),
    PdfJsViewerModule,
    NgxSpinnerModule,
    FormsModule,
    SharedModule,
  ],
  declarations: [
    BaseEntryLiteratureComponent,
    LiteratureEntryComponent,
    TopFormsComponent,
    ItemDetailComponent,
    LitBannerComponent,
    FeaturedLiteratureComponent,
    LiteratureEmailFormComponent,
    // LiteratureDocumentComponent,
    LiteratureDocumentListingComponent,
    DocumentDownloadComponent,
    IconColumnComponent,
    DocumentFiltersComponent,
    IconColumnComponent,
    LiteratureDocumentCardComponent,
    LiteratureDocumentCardContainerComponent,
    LiteratureFundDocumentComponent,
    LiteratureDocumentCartComponent,
    FundDocumentCardComponent,
    FundDocumentCardContainerComponent,
    OrderHistoryListComponent,
    LiteratureOrderHistoryDetailComponent,
    NoRowOverlayRenderComponent,
    LiteratureOrderHeaderComponent,
    DocumentDetailComponent,
    FundNameCellRendererComponent,
    LiteratureYourCartMailFormComponent,
    LiteratureYourCartMailComponent,
    LiteratureYourCartMailConfirmOrderComponent,
    LiteratureYourCartMailOrderSuccessComponent,
    MyCartSummaryComponent,
    OrderNameCellRenderComponent,
    ComplimentaryLiteratureComponent,
    ComplementaryCommonComponent,
    LiteratureDashboardComponent,
    LiteratureCustomDocumentCardComponent,
    NoFilterDataOverLayComponent,
    FundCommentaryComponent,
    MyLiteratureComponent,
    NoRowOverlayRenderMyLiteratureComponent,
    RegulatoryFundNameCellRendererComponent,
    LiteraturePreviewComponent,
    SelectAllGroupHeaderComponent,
    SelectCellRendererComponent,
    SmarshLiteratureListingComponent,
    LiteratureGlobalRegulatoryListingComponent,
  ],
  entryComponents: [
    LiteratureEntryComponent,
    TopFormsComponent,
    ItemDetailComponent,
    LitBannerComponent,
    FeaturedLiteratureComponent,
    LiteratureDocumentListingComponent,
    DocumentDownloadComponent,
    IconColumnComponent,
    LiteratureFundDocumentComponent,
    LiteratureDocumentCartComponent,
    OrderHistoryListComponent,
    LiteratureOrderHistoryDetailComponent,
    NoRowOverlayRenderComponent,
    LiteratureOrderHeaderComponent,
    MyCartSummaryComponent,
    ComplimentaryLiteratureComponent,
    LiteratureDashboardComponent,
    NoFilterDataOverLayComponent,
    FundCommentaryComponent,
    SmarshLiteratureListingComponent,
    NoRowOverlayRenderMyLiteratureComponent,
  ],
  exports: [],
  providers: [
    TopFormService,
    LiteratureDataService,
    ItemDetailService,
    FeaturedLiteratureService,
    LiteratureDocumentListingService,
    LiteratureFundDataService,
    OrderHistoryListService,
    LiteratureFundDocumentService,
    LiteratureOrderHistoryDetailService,
    ComplimentaryLiteratureService,
    MyliteratureService,
    FundCommentaryService,
  ],
})
export class LiteratureModule implements DynamicModule {
  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
  }

  getComponentMapping(): ComponentMapping {
    return {
      Literature: LiteratureEntryComponent,
      'Literature Banner': LitBannerComponent,
      'Fund Document': LiteratureFundDocumentComponent,
      'Fund Commentary': FundCommentaryComponent,
      'Literature Item Details': ItemDetailComponent,
      'Literature Order History Detail': LiteratureOrderHistoryDetailComponent,
      'Cart Summary': MyCartSummaryComponent,
      'Literature Complementary Mandatory': ComplimentaryLiteratureComponent,
      'SmarshBot Listing': SmarshLiteratureListingComponent,
    };
  }
}
